import { render, staticRenderFns } from "./PromoItemSelection.vue?vue&type=template&id=4c228816&scoped=true"
import script from "./PromoItemSelection.vue?vue&type=script&lang=js"
export * from "./PromoItemSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c228816",
  null
  
)

export default component.exports